import React from 'react';

import CreateReportPage from '~/presentation/pages/CreateReport';

export const CreateDiagnosisReportFactory: React.FC = () => {
  return <CreateReportPage />;
};
